module.exports = __webpack_public_path__ + "static/media/wpe2.png.700e00c2.jpg";